import React from "react";
import PropTypes from "prop-types";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { observer, PropTypes as mbxPropTypes } from "mobx-react";

// Local modules
import PlayerRows from "./PlayerRows";

const tableHeadings = [
  { name: "Edit", small: true },
  { name: "Rule Scope", small: false },
  { name: "Global max pay", small: false },
  { name: "CWS live", small: false },
  { name: "EZ live", small: false },
  { name: "Reverse counts double", small: true },
  { name: "Reverse Limit", small: true },
  { name: "Live casino weekly limit", small: true },
  { name: "UI Version", small: true },
];

const PlayerList = observer(
  ({ classes, playerList, anchorEls, handleClick, handleClose }) => {
    return (
      <Table>
        <TableHead>
          <TableRow>
            {tableHeadings.map((heading, i) => {
              return (
                <TableCell
                  className={classes.smallCell}
                  key={`agent-config-table-${i}`}
                >
                  {heading.name}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <PlayerRows
          {...{
            classes,
            playerList,
            anchorEls,
            handleClick,
            handleClose,
          }}
        />
      </Table>
    );
  }
);

PlayerList.propTypes = {
  classes: PropTypes.object.isRequired,
  playerList: mbxPropTypes.observableArrayOf(PropTypes.object),
};

export default PlayerList;
